import { HttpClient } from "@angular/common/http";
import { SCAMP_API } from "src/environments/environment";
import { AccountService } from "./account.service";
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./account.service";
export class LogService {
    constructor(http, account) {
        this.http = http;
        this.account = account;
    }
    getAllByOSId(osid) {
        return this.http.get(`${SCAMP_API.accountApiV1}/logs-alteracoes-oss/${osid}`, { headers: this.account.composeHeaders() });
    }
    post(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/logs-alteracoes-oss`, data, { headers: this.account.composeHeaders() });
    }
    postAvaliacao(data) {
        return this.http.post(`${SCAMP_API.accountApiV1}/logs-avaliacoes-oss`, data, { headers: this.account.composeHeaders() });
    }
    getLogAvaliacoesPelaOSId(osid) {
        return this.http.post(`${SCAMP_API.accountApiV1}/logs-avaliacoes-oss-por-osid/${osid}`, null, { headers: this.account.composeHeaders() });
    }
}
LogService.ngInjectableDef = i0.defineInjectable({ factory: function LogService_Factory() { return new LogService(i0.inject(i1.HttpClient), i0.inject(i2.AccountService)); }, token: LogService, providedIn: "root" });
